import React, { ReactNode, useState } from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { Box, Typography, Menu, MenuItem, IconButton } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';

export interface PageTitleMenuItem {
  key: string;
  path: string;
  label: ReactNode;
}

interface PageTitleMenuProps {
  current: string;
  title: string;
  items: PageTitleMenuItem[];
}

export const PageTitleMenu = ({
  current,
  title,
  items,
}: PageTitleMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <HeaderButton
        onClick={handleClick}
        aria-label={`Open menu for ${title}`}
        aria-controls={open ? 'page-title-menu' : undefined}
        aria-haspopup="menu"
        aria-expanded={open ? 'true' : undefined}
      >
        <IconButton
          size="small"
          edge="start"
          sx={{ p: 0.5, mr: 0.5 }}
          tabIndex={-1}
          disableRipple
        >
          <MenuIcon fontSize="small" />
        </IconButton>

        <Typography variant="h4" component="h1">
          {title}
        </Typography>
      </HeaderButton>

      <Menu
        id="page-title-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {items.map((item) => (
          <MenuItem
            key={item.key}
            selected={item.key === current}
            component={Link}
            to={item.path}
            onClick={handleClose}
            sx={{
              color: 'text.primary',
              textDecoration: 'none',
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

const HeaderButton = styled(Box)`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  border-radius: 4px;
  padding: 4px 8px;
  margin-left: -8px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;
